/** "Book now" on a compliance overdue flag: books today's Visit on the flag's line and opens it. */
import { ActivityEntityName, ComplianceOverdueBookNowRequest, ComplianceOverdueFlagCommandId, VisitInstance } from '@jms/model';
import type { EntityDataServiceRaw } from '@workbuddy/services/entities/entity.data.service.raw';
import type { ToastService } from '@workbuddy/ui/services';
import type { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';
import { firstValueFrom } from 'rxjs';

export interface ComplianceBookNowDeps {
  readonly entities: EntityDataServiceRaw;
  readonly inspectors: EntityInspectors;
  readonly toasts: ToastService;
}

/** Opens the Visit so the user can dispatch it; booking alone does not satisfy the flag. True when a Visit opened. */
export async function bookComplianceVisit(deps: ComplianceBookNowDeps, flagId: string): Promise<boolean> {

  try {
    const request: ComplianceOverdueBookNowRequest = { flagId };
    const visit = await firstValueFrom(deps.entities.executeCommand<VisitInstance>(ActivityEntityName.Flag, ComplianceOverdueFlagCommandId.BookNow, request));
    if (!visit?._id) throw new Error('No Visit was booked for today.');
    // The Visit's quick view, where Dispatch sits in its ⋯ menu.
    await deps.inspectors.open({ entity: ActivityEntityName.Visit, operation: 'preview', id: visit._id });
    return true;
  } catch (error) {
    // HttpErrorResponse is not an Error; the API's reason (e.g. a non-working day) rides on `error.message`.
    deps.toasts.error('Book now failed', (error as { error?: { message?: string } })?.error?.message ?? (error instanceof Error ? error.message : 'Please try again.'));
    return false;
  }
}
